<template>
  <div id="sendMail" :class="[$mq, {TA:isTestAchat}]" >
    <a @click="click()" class="button inverted" :class="[$mq === 'mobile' ? 'main' : 'secondary']">
      <SvgIcon icon="mail" class="icon" fill></SvgIcon> {{ $t(`mail`) }}
    </a>
    <div class="modal-background" @click.self="close()" v-if="showModal">
      <div class="modal-wrapper" :class="$mq">
        <div class="modal">
          <h1>
            {{ $t("mail") }}
            <span class="close" @click="close()"
              ><SvgIcon icon="close" fill></SvgIcon
            ></span>
          </h1>
          <label class="content" for="mail">
            <h4>{{ $t("step4.contact.mail") }}</h4>
            <ValidationObserver ref="observer" v-slot="{ valid }" slim>
              <ValidationProvider
                :rules="{ required: true, email: true }"
                v-slot="{ errors }"
                :customMessages="{ required: $t('step4.contact.required') }"
              >
                <div :class="{error: errors.length}">
                  <InputField
                    type="text"
                    id="mail"
                    v-model="mailTmp"
                    @blur="setMail()"
                    name="mail"
                  />
                  <!-- <input
                    type="text"
                    id="mail"
                    v-model="mailTmp"
                    @blur="setMail()"
                    name="mail"
                    class="input"
                  /> -->
                  <span class="input-error" :class="[$mq, {TA:isTestAchat}]">{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
            </ValidationObserver>
            <div
              class="inline margin h-item-margin"
              v-if="!consentAtStart && !isTestAchat"
              @click="consent = !consent"
            >
              <div class="check-button" :class="{ active: consent }"></div>
              <div class="txt-left grow small">
                {{ $t(`step4.consent.text`) }}
              </div>
            </div>
            <div class="buttons" :class="$mq">
              <NextButton @click="send()" :label="$t('validate')" />
              <!-- <button @click="send()" class="button main">
                {{ $t("validate") }}
              </button> -->
              <div class="error" v-if="error">{{ $t(`step4.${error}`) }}</div>
            </div>
          </label>
        </div>
      </div>
    </div>
    <div class="modal-background" v-if="showConfirmation" @click.self="close()">
      <div class="modal-wrapper" :class="$mq">
        <div class="modal">
          <h1>
            {{ $t("mail") }}
          </h1>
          <p>{{ $t(`mailSent`) }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import InputField from '@/components/Form/InputField.vue';
import NextButton from '@/components/NextButton.vue';
import SvgIcon from "@/components/SvgIcon";

export default {
    data: () => {
        return {
            error: null,
            showModal: false,
            showConfirmation: false,
            consentAtStart: false,
            mailTmp: null,
        };
    },
    computed: {
        ...mapGetters("common", ["isTestAchat"]),
        mail: {
            get() {
                return this.$store.state.contact.mail;
            },
            async set(value) {
                this.$store.commit("contact/setMail", value);
                await this.$store.dispatch("contact/save");
            },
        },
        consent: {
            get() {
                return this.$store.state.contact.consent;
            },
            set(value) {
                this.$store.commit("contact/setConsent", value);
            },
        },
    },
    methods: {
        close() {
            this.showModal = false;
        },
        click() {
            if (!this.$store.state.contact.mail || !this.consent) {
                this.showModal = true;
            }
            else {
                this.send();
            }
        },
        async setMail() {
            if (await this.$refs.observer.validate()) {
                this.mail = this.mailTmp;
                // this.consent = true;
            }
        },
        async send() {
            if (this.$store.state.contact.mail ||
                (await this.$refs.observer.validate())) {
                this.showModal = false;
                this.showConfirmation = true;
                setTimeout(() => {
                    this.$emit("send");
                    this.showConfirmation = false;
                }, 3000);
            }
        },
    },
    created() {
        this.mailTmp = this.mail;
        this.consentAtStart = this.consent;
    },
    components: { InputField, NextButton, SvgIcon }
};
</script>

<style lang="scss" scoped>
#sendMail {
  .icon {
    display: inline-block;
    margin-left: 5px;
  }

  .content {
    margin: 2px;
    width: 100%;
  }

  .input {
    // min-width: 100px;
    font-family: "ObjectSans", Helvetica, Arial, sans-serif;
    font-size: 1rem;
    padding: 5px 10px;
    border-radius: 4px;
    border: 2px solid $yellow;
    margin: 0;

    &:focus {
      outline: none !important;
      border: 2px solid $yellow;
      -webkit-appearance: none;
      -webkit-box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.3);
      box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.3);
    }

    &.TA {
      border: 2px solid $pink;
      font-family: "Lato", Helvetica, Arial, sans-serif;
    }
  }

  .input-error {
    margin: 10px;
    display: block;
    color: #f58b1e;
    display: block;

    &.TA {
      color: $pink;
      font-family: "Lato", Helvetica, Arial, sans-serif;
    }
  }
}

.check-button {
  width: 20px;
  height: 20px;
  border: 2px solid #888;

  &.radio {
    border-radius: 50%;
  }

  &.active {
    border: 2px solid #fdcb47;
    background: #fdcb47;
    position: relative;

    &::before {
      content: "";
      left: 0.4em;
      top: 0.1em;
      position: absolute;
      border-color: #fff;
      border-style: solid;
      border-width: 0 0.1em 0.1em 0;
      height: 0.8em;
      transform: rotate(45deg);
      width: 0.3em;
    }
  }
}

.mobile .button.main {
  padding: 7px 15px;
  font-size: .7rem!important;
}

.TA {
  .button.inverted {
    text-decoration: underline $pink;
    color: $pink
  }
}
</style>



// WEBPACK FOOTER //
// src/views/components/SendMail.vue